var exports = {
  "u": "ExternalLink.module__externalLink___cEJqY1",
};

module.exports = exports;
